import React from "react";
import { useHistory } from "react-router-dom";
import { Link } from "react-router-dom";

import { useDispatch } from "hooks";
import { Title, Subtitle, Paragraph, BottomImage } from "./styled";
import { StyledGrid, Button } from "components/simple";
import imgNotFound from "assets/not_found.svg";
import { spacingDefaults } from "style/constants";

interface Props {
  callback(): void;
}

export const ResultNotFound: React.FC<Props> = ({ callback }: Props) => (
  <StyledGrid textAlign={"center"} marginTop={spacingDefaults.normal}>
    <img src={imgNotFound} alt="Two empty clipboards" />
    <p>No Results Found</p>
    <Button onClick={() => callback()}>Go Back</Button>
  </StyledGrid>
);

export const PageNotFound: React.FC = () => {
  return (
    <>
      <StyledGrid
        centerContent
        container
        direction="column"
        fillRemainingHeight
        itemMargin="2rem"
        marginTop="-4rem"
      >
        <StyledGrid item>
          <Title>404</Title>
        </StyledGrid>
        <StyledGrid item>
          <Subtitle>This page was lost</Subtitle>
        </StyledGrid>
        <StyledGrid item>
          <Paragraph>
            The page you’re looking for isn’t available. Try to search again or use the Go Back
            button below.
          </Paragraph>
        </StyledGrid>
        <StyledGrid item>
          <Link to="/">
            <Button>Go back</Button>
          </Link>
        </StyledGrid>
      </StyledGrid>
      <BottomImage />
    </>
  );
};

export const ServerError: React.FC = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  return (
    <>
      <StyledGrid
        centerContent
        container
        direction="column"
        fillRemainingHeight
        itemMargin="2rem"
        marginTop="-4rem"
      >
        <StyledGrid item>
          <Title>500</Title>
        </StyledGrid>
        <StyledGrid item>
          <Subtitle>Something went wrong</Subtitle>
        </StyledGrid>
        <StyledGrid item>
          <Paragraph>There was an internal server error. Please try again later.</Paragraph>
        </StyledGrid>
        <StyledGrid item>
          <Button
            onClick={() => {
              dispatch({ type: "server_error", value: false });
              history.push("/");
            }}
          >
            Go back
          </Button>
        </StyledGrid>
      </StyledGrid>
      <BottomImage />
    </>
  );
};
